<template>
  <va-edit-layout>
    <proyects-form :id="id" :title="title" :item="item"></proyects-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
